/** Set when the athlete dismisses the native-app screen from the mobile web app. */
export const NATIVE_APP_PROMPT_DISMISSED_KEY = "peakNativeAppPromptDismissed";

const OUTSIDE_MAIN_APP = new Set([
  "/landing",
  "/login",
  "/forgot-password",
  "/reset-password",
  "/auth",
  "/privacy-policy",
  "/terms-of-service",
  "/peak-score",
  "/complete-profile",
  "/account-deactivated",
  "/complete-account-removal",
  "/share",
  "/connectionresult",
  "/connectionsuccess",
  "/connectionfailed",
]);

const OUTSIDE_MAIN_APP_PREFIXES = ["/onboarding", "/admin"];

/** Signed-in product surfaces (dashboard, diary, settings, and the rest of the shell). */
export function isMainAppPath(pathname: string): boolean {
  if (OUTSIDE_MAIN_APP.has(pathname)) return false;
  return !OUTSIDE_MAIN_APP_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

/**
 * Phones and tablets. Desktop browsers stay on the web app, including a
 * narrow window. iPadOS 13+ reports itself as a Mac, so a touch Mac is included.
 */
export function isHandheldDevice(
  userAgent: string = typeof navigator !== "undefined" ? navigator.userAgent : "",
  platform: string = typeof navigator !== "undefined" ? navigator.platform : "",
  maxTouchPoints: number = typeof navigator !== "undefined" ? navigator.maxTouchPoints : 0,
): boolean {
  if (/Android|iPhone|iPad|iPod|Mobile/i.test(userAgent)) return true;
  if (platform === "MacIntel" && maxTouchPoints > 1) return true;
  return false;
}

export function shouldPreferNativeApp(options: {
  hasUser: boolean;
  pathname: string;
  search: string;
  handheld: boolean;
}): boolean {
  if (!options.hasUser || !options.handheld) return false;
  if (new URLSearchParams(options.search).get("walkthrough") === "true") return false;
  return isMainAppPath(options.pathname);
}
